<template>
  <div class="list-box">
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :min-width="140">
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="时间" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <div
                  class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                  @click="
                    $openMenu({
                      path: 'HuiYiDetailRiChengDetail',
                      title: '日程详情-' + row.name,
                      refresh: true,
                      data: {
                        id: row.id,
                        meeting_id: row.meeting_id,
                        search: true,
                      },
                    })
                  "
                >
                  <strong>{{ row.name }}</strong>
                </div>
              </template>
              <template #bottom>
                <div class="flex items-center gap-x-2">
                  <text class="text-gray-700 text-sm">
                    {{ row.start_time + " ~ " + row.end_time }}
                  </text>
                  <text class="text-gray-400 text-xs">{{ row.date }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="类型"
          prop="lx"
          :formatter="$tab_TextFormat"
          :width="120"
          align="center"
        >
          <template #default="{ row }">
            <c_status
              arrName="Meeting_Schedule_Type"
              :value="row.type"
              class="m-auto"
              showBg
              :key="row.type"
            />
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="会场" label2="位置" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.meetingPlace?.name"
              :value2="
                row.meetingPlace?.hotel?.name +
                ' - ' +
                row.meetingPlace?.hotelHall?.name
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          label="说明"
          prop="intro"
          :formatter="$tab_TextAreaFormat"
          :min-width="160"
        />
        <el-table-column label="是否显示" align="center">
          <template #default="{ row }">
            <el-switch
              v-model="row.is_site_show"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              active-text="是"
              inactive-text="否"
              inline-prompt
              @change="onUpdateSiteShow($event, row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_website_schedule_page,
  meeting_website_schedule_updateStatus,
} from "@/http/meeting";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
    meeting_schedule_id: Number,
  },
  components: {},
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_website_schedule_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(() => {}, row.id, onLoad, {
        filed: "会议",
        name: row.name,
      });
    };

    const onUpdateSiteShow = (value, row) => {
      ElMessageBox.confirm(
        `您确定设置该日程${
          row.is_site_show == 1
            ? '<strong style="color: var(--el-color-success);">在网站中显示</strong>'
            : '<strong style="color: var(--el-color-danger);">不在网站中显示</strong>'
        }吗？`,
        "是否在网站显示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          meeting_website_schedule_updateStatus({
            meeting_id: props.meeting_id,
            id: row.id,
            is_site_show: value,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.is_site_show = value ? 0 : 1;
        });
    };

    return { state, onLoad, onDelete, onUpdateSiteShow };
  },
};
</script>

<style lang="scss" scoped></style>
